import whenDomReady from "when-dom-ready"

whenDomReady(() => {
    let elJsToggle = document.querySelectorAll('.js-toggle')

    elJsToggle.forEach(function (element) {
        element.addEventListener('click', function (event) {
            let targetToggle = this.dataset.target
            let targetClass = this.dataset.class
            let targetFocus = this.dataset.focus

            let elTarget = document.querySelector(targetToggle)

            if (elTarget != null) {
                elTarget.classList.toggle(targetClass)
            }

            if (elTarget.classList.contains(targetClass) && targetFocus != null) {
                let elFocus = document.querySelector(targetFocus)
                if (elFocus != null) [
                    elFocus.focus()
                ]
            }
        })
    })

})
